<template>
  <div>
    <Table :data="tableData" class="table" :labels="tableLabels" size="sm" />
  </div>
</template>

<script>
import { metadataUrl } from "@/mixins";
import { prepareRows } from "@/lib/metaDataHelper";

export default {
  mixins: [metadataUrl],
  props: {
    metaData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      tableLabels: [
        this.$t("pages.datasetDetail.metaTable.field"),
        this.$t("pages.datasetDetail.metaTable.value")
      ]
    };
  },
  methods: {
    parseMetadata(data) {
      return Object.entries(data).map(row => prepareRows(this, row));
    }
  },
  mounted() {
    this.tableData = this.parseMetadata(this.metaData);
  }
};
</script>

<style lang="scss" scoped>
.table {
  margin: 55px 0 80px;
}
</style>
